@if (invitationsStore.isLoading() || contactsStore.isLoading()) {
  <div class="flex w-full h-full items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
} @else {
  <div class="sidebar-wrapper">
    <app-sidebar-header>
      <div mainTitle>
        <div class="w-full flex items-center justify-between">
          <div>Invite to Project</div>
          <i
            class="icon-info-filled text-navy-700 text-size_icon_bigger"
            appTooltip='An invitation is sent out based on the type of contact selected.
            For example, if the contact is an "Owner" the invitation is for a Prime Contract.
            However, if the contact is a "Service Provider", such as a subcontractor, the invitation is for a Commitment or a Subcontract.'
            tooltipPosition="left"
          ></i>
        </div>
      </div>
    </app-sidebar-header>

    <div class="main-content">
      <app-dropdown
        required
        placeholder="Select Project"
        label="Project"
        [options]="projects()"
        optionValue="id"
        optionLabel="title"
        [ngModel]="model().project_id"
        (ngModelChange)="updateModel('project_id', $event)"
      ></app-dropdown>

      <app-dropdown
        required
        placeholder="Select Contact"
        label="Contact"
        [options]="contacts()"
        optionValue="id"
        [ngModel]="model().contact_id"
        (ngModelChange)="updateModel('contact_id', $event)"
      >
        <ng-template #optionContent let-option>
          <div class="flex gap-1">
            <span class="font-bold">{{ option?.first_name }} {{ option.last_name }},</span>
            <span class="font-normal">{{ option.company_name }}</span>
          </div>
        </ng-template>

        <ng-template #selectedContent let-option>
          <div class="flex gap-1">
            <span class="font-bold">{{ option?.first_name }} {{ option.last_name }},</span>
            <span class="font-normal">{{ option.company_name }}</span>
          </div>
        </ng-template>
      </app-dropdown>

      <app-dropdown
        required
        placeholder="Invite For"
        label="Invite For"
        [options]="inviteForOptions()"
        optionValue="id"
        [ngModel]="model().invite_for"
        (ngModelChange)="updateModel('invite_for', $event)"
      >
        <ng-template #selectedContent #optionContent let-option>
          <div class="flex gap-1">
            @if (option.id === 'prime_contract') {
              <span>Prime Contract,</span>
              <span class="text-green-600">
                @if (userService.isManager) {
                  General Contractor
                } @else {
                  Owner
                }
              </span>
            } @else if (option.id === 'commitment') {
              <span>Commitment,</span>
              <span class="text-blue-600">Subcontractor</span>
            } @else if (option.id === 'no-commitment') {
              <span>No Commitment,</span>
              <span class="text-grey-500">Collaborators</span>
            }
          </div>
        </ng-template>
      </app-dropdown>
    </div>

    <div class="buttons flex justify-end">
      <app-simple-button (click)="save()" buttonStyle="color_accent_filled">Save</app-simple-button>
    </div>
  </div>
}
